import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import fr from './fr.json';

/**
 * i18n is configured to load French only in v1 — the namespace structure
 * (locale → JSON file) is set up to support additional languages later
 * without code changes (sprint 6 backlog 6.0).
 */
void i18n.use(initReactI18next).init({
  resources: {
    fr: { translation: fr },
  },
  lng: 'fr',
  fallbackLng: 'fr',
  interpolation: {
    escapeValue: false,
  },
  returnNull: false,
});

export default i18n;
